import { DAY_IN_SECONDS, SECOND_IN_MILLISECONDS, YEAR_IN_DAYS } from '@vaultsfyi/common/constants'
import { fromDecimal } from '@vaultsfyi/common/utils'

interface Props {
  initialValue: number
  apy: number
  durationInDays: number
  startTimestamp?: number
}

export function getPredictedValues({ initialValue, apy, durationInDays, startTimestamp }: Props) {
  const dailyRate = fromDecimal(apy) / YEAR_IN_DAYS
  const data = []

  let currentValue = initialValue
  let currentTimestamp = startTimestamp ?? new Date().getTime()

  const endTimestamp = currentTimestamp + durationInDays * DAY_IN_SECONDS * SECOND_IN_MILLISECONDS

  while (currentTimestamp < endTimestamp) {
    data.push({
      timestamp: currentTimestamp,
      value: currentValue,
    })

    currentValue = currentValue * (1 + dailyRate / 100)
    currentTimestamp = currentTimestamp + DAY_IN_SECONDS * SECOND_IN_MILLISECONDS
  }

  return data
}
